export const permissionDenied: string =
  'You do not have the permission(s) needed to perform this action.  Contact your administrator.'

export const notAuthenticated = 'You must be logged in to perform this action.'

export const lastLocationService: string =
  'You cannot remove the only service location.'

export const hasActiveAppointementMessage: string =
  'This service location cannot be removed because it has a scheduled appointment.'
export const updateLocationUnmatched =
  'Your user type does not allow this action.'
export const updateLocationNoPermission =
  "You don't have permission to perform this action."

export const isAllServicesAssignedToLocationMessage: string =
  'You cannot remove the only location with services. Add services to another location to delete this one.'

export const createLocationPermission: string = 'accounts_create'
